<template>
  <main class="task-page">
    <div class="container">
      <div>
        <TaskList :tasks="tasks"
                  show-header="true"
                  :header-text="$t('taskPage.messages')"
                  object-type="messages"
                  :table-columns="['TaskNr', 'LatestMessageUser', 'LatestMessageMessage', 'LatestMessageTime']"
                  preference-key="messages"
        />
      </div>
    </div>
  </main>
</template>
<script setup>
import { onMounted, computed } from 'vue'
import i18n from '../locales/i18n'
import { useStore } from 'vuex'
import TaskList from '@/components/task/TaskList.vue'
const store = useStore()

const tasks = computed(() => {
  const allMessages = store.state.message.messages

  const messagesDictionary = allMessages.reduce((dictionary, message) => {
    if (!dictionary[message.TaskId] || message.Created > dictionary[message.TaskId].Created) {
      dictionary[message.TaskId] = message
    }
    return dictionary
  }, {})

  // Convert the dictionary back to an array of values
  const latestMessages = Object.values(messagesDictionary)

  // Sort the array by Created property in descending order
  latestMessages.sort((a, b) => new Date(b.Created) - new Date(a.Created))

  // Create a new array with modifications
  const modifiedMessages = latestMessages.map(message => {
    const unreadCount = store.state.message.unreadByTask[message.TaskId] || 0
    return { ...message, Unread: unreadCount }
  })

  return modifiedMessages
})

onMounted(async () => {
  store.dispatch('message/getBaseData')
  store.commit('sidebar/setCurrentPageHeaderText', i18n.global.t('taskPage.Task'))
})

</script>

<style lang="scss" scoped>
.task-page {
  height: 100vh;
  overflow-y: scroll;
  font-family: 'Lexend', sans-serif;
  text-align: center;
  color: #2c3e50;
  background: linear-gradient(90deg, var(--taskBackgroundColor1) 0%, var(--taskBackgroundColor2) 10px);
}

.container{
  padding: 1rem;
  min-width: unset;
  width:1;
}

.styled-table {
  table-layout: fixed;
  border-collapse: collapse;
  margin: 5px 0;
  font-size: 0.9em;
  font-family: 'Lexend', sans-serif;
  width: 100%;
  box-shadow: 0 0 20px rgba(0, 0, 0, 0.5);
}

.styled-table thead tr {
  background-color: var(--mainBlue);
  color: white;
  text-align: left;
}

.styled-table th {
  padding: 12px 15px;
  text-align: left;
}

.styled-table tbody tr {
  border-bottom: 1px solid lightgrey;
  background-color: white;
  color: black;
}

.styled-table tbody tr:nth-of-type(4n-1),
.styled-table tbody tr:nth-of-type(4n) {
  background-color: var(--alternatingListColor);
  color: black;
}

.styled-table tbody tr:last-of-type {
  border-bottom: 3px solid var(--mainBlue);
}

.table-row:hover {
  background-color: #f5f5f5;
}

.button {

}

</style>
